<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un delito</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los delitos</option>
        <option v-for="Delito in Delitos" :value="Delito.DelitoId" :key="Delito.DelitoId">{{Delito.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        Delitos: [],
        idDelModelo: null,
        comun
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted() {      
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;
  
      //alert(valorDefinido);
      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_PJ_Catalogo_Establecer008Delitos", parametros);
    },
    methods:
    {
      cargaCatalogoDeDelitos: function() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba

        axios.post(api.conexion + api.PJ.catalogos.C008Delitos, this.parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.Delitos = respuesta.data.Delitos;
              if(this.tipo.Id == enumeraciones.tiposDeSelect.Ninguno.Id && this.Delitos.length >= 1 && (!this.valorDefinido || this.valorDefinido <= 0))
              {
                this.idDelModelo = this.Delitos[0].DelitoId;
                this.elegirPrimerElemento(this.Delitos[0].DelitoId);
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_PJ_Catalogo_Establecer008Delitos", parametros);
        this.$emit("valorParaElPadre", evento);        
      },
      elegirPrimerElemento(id) {
        const parametros = {
          llave: this.idDelInput,
          valor: id
        }
        
        this.$store.dispatch("A_PJ_Catalogo_Establecer008Delitos", parametros);        
        this.$emit("valorParaElPadrePrimerElemento", id);
      }
    },
    created() {
      this.cargaCatalogoDeDelitos();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/008Delitos.vue